import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './components/pages'
import configureStore from './reducers'
import { StoreContext } from 'redux-react-hook'
import registerServiceWorker from './registerServiceWorker'
import GlobalStyle from '../src/components/utils/globalstyle'
const store = configureStore()
ReactDOM.render(
  <StoreContext.Provider value={store}>
    <GlobalStyle />
    <App />
  </StoreContext.Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx